import { lazy } from 'react';
import { User, Bell, BarChart2, Scale } from 'lucide-react';
import { createRoute } from './utils';
import { AppRouteConfig, RouteDefinition } from '@/types/routes';

// Lazy load monitoring components
const UserActivityPage = lazy(() => import('@/pages/monitoring/UserActivityPage'));
const TurnFlowPage = lazy(() => import('@/pages/monitoring/TurnFlowPage'));
const AlertsPage = lazy(() => import('@/pages/monitoring/AlertsPage'));
const AnalyticsPage = lazy(() => import('@/pages/monitoring/AnalyticsPage'));
const ComplianceShadowPage = lazy(() => import('@/pages/monitoring/ComplianceShadowPage'));

// Monitoring section routes
export const monitoringSection: AppRouteConfig = {
  sectionTitle: 'Monitoring',
  routes: [
    createRoute('user-activity', <UserActivityPage />, 'User Activity', User) as RouteDefinition,
    createRoute('user-activity/:logId/flow', <TurnFlowPage />, 'Turn flow', undefined, {
      hidden: true,
    }) as RouteDefinition,
    createRoute('alerts', <AlertsPage />, 'Violation Alerts', Bell) as RouteDefinition,
    createRoute('analytics', <AnalyticsPage />, 'Usage Analytics', BarChart2) as RouteDefinition,
    createRoute('compliance-shadow', <ComplianceShadowPage />, 'Compliance Shadow', Scale, {
      hidden: true,
    }) as RouteDefinition,
  ],
};
